import api from "../helpers/util";

export const fetchCustomers = async () => {
  try {
    const response = await api.get("/customers");
    return response?.data?.result ?? "No customers found.";
  } catch (error) {
    throw new Error("Error fetching customers:", error);
  }
};

// Create new customer
export const createCustomer = async (customerData) => {
  try {
    const response = await api.post("/customers", customerData);
    return response.data.result;
  } catch (error) {
    // Preserve the real axios error (status + server message) instead of
    // discarding it - `new Error(msg, error)` silently drops the 2nd arg,
    // which is why the UI only ever showed a generic message.
    console.error(
      "Error creating customer:",
      error?.response?.status,
      error?.response?.data || error.message
    );
    throw error;
  }
};

// Update customer details (name, delivery method)
export const updateCustomerDetails = async (customerId, detailsData) => {
  try {
    const response = await api.put(
      `/customers/${customerId}/details`,
      detailsData
    );
    return response.data.result;
  } catch (error) {
    console.error("Error updating customer details:", error);
    throw new Error("Error updating customer details:", error);
  }
};

// Fetch all contacts for a customer
export const fetchCustomerContacts = async (customerId) => {
  try {
    const response = await api.get(`/customers/${customerId}/contacts`);
    return response?.data?.result ?? [];
  } catch (error) {
    throw new Error("Error fetching customer contacts:", error);
  }
};

// Bulk-replace all contacts for a customer
export const updateCustomerContacts = async (customerId, contacts) => {
  try {
    const response = await api.put(`/customers/${customerId}/contacts`, {
      contacts,
    });
    return response.data.result;
  } catch (error) {
    console.error("Error updating customer contacts:", error);
    throw new Error("Error updating customer contacts:", error);
  }
};

// Update customer addresses (billing + delivery addresses)
export const updateCustomerAddresses = async (customerId, addressData) => {
  try {
    const response = await api.put(
      `/customers/${customerId}/addresses`,
      addressData
    );
    return response.data.result;
  } catch (error) {
    console.error("Error updating customer addresses:", error);
    throw new Error("Error updating customer addresses:", error);
  }
};

// DEPRECATED - kept for backward compatibility
export const createorUpdateCustomer = async (customerData, customerId) => {
  console.warn("⚠️ DEPRECATED: Use createCustomer, updateCustomerDetails, updateCustomerContacts, or updateCustomerAddresses instead");
  try {
    if (customerId) {
      const response = await api.put(
        `/customers/updateCustomer`,
        customerData
      );
      return response.data.result;
    } else {
      const response = await api.post("/customers", customerData);
      return response.data.result;
    }
  } catch (error) {
    console.log("error api", error);
    throw new Error("Error updating customer:", error);
  }
};

export const deleteCustomer = async (customerId) => {
  try {
    const response = await api.delete("/customers/" + customerId);
    return response;
  } catch (error) {
    console.log("api err", error);
    throw error;
  }
};